var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zlItCourseEdit" }, [
    _c(
      "div",
      { staticClass: "zlItCourseEdit_tree" },
      [
        _c("div", { staticClass: "goback", on: { click: _vm.goback } }, [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v("返回\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "zlItCourseEdit_name" }, [
          _vm._v(_vm._s(_vm.courseName))
        ]),
        _vm._v(" "),
        _c("zl-sidebar", {
          ref: "zlSidebar",
          attrs: { courseId: _vm.courseId, subjectId: _vm.subjectId },
          on: {
            setStatus: _vm.setStatus,
            openAddResoures: _vm.openAddResoures,
            handleTreeNodeClick: _vm.handleTreeNodeClick
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.zl_loading,
            expression: "zl_loading"
          }
        ],
        staticClass: "zlItCourseEdit_content"
      },
      [
        _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
          _vm.status === 1
            ? _c(
                "div",
                { staticClass: "zlItCourseEdit_show_status_1" },
                [
                  _c("div", { staticClass: "chapterHead" }, [
                    _c("span", { staticClass: "chapterName" }, [
                      _c("span", { staticClass: "kk" }, [
                        this.addType
                          ? _c("img", {
                              attrs: {
                                src:
                                  "../../static/images/newCourseImages/" +
                                  _vm.courseIcon[this.addType].image,
                                alt: _vm.courseIcon[this.addType].alt
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.catalogue.catalogName) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.editor }
                          },
                          [_vm._v("编辑")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("status_1_content", {
                    model: {
                      value: _vm.chapter,
                      callback: function($$v) {
                        _vm.chapter = $$v
                      },
                      expression: "chapter"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
          _vm.status === 2
            ? _c("div", { staticClass: "zlItCourseEdit_editor_status_2" }, [
                _c("div", { staticClass: "chapterHead" }, [
                  _c(
                    "span",
                    { staticClass: "chapterName" },
                    [
                      _c("span", { staticClass: "kk" }, [
                        _c("img", {
                          attrs: {
                            src:
                              "../../static/images/newCourseImages/" +
                              _vm.courseIcon[this.addType].image,
                            alt: _vm.courseIcon[this.addType].alt
                          }
                        })
                      ]),
                      _vm._v(" "),
                      !_vm.isEditor
                        ? _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { size: "small", placeholder: "请输入名称" },
                            model: {
                              value: _vm.sectionName,
                              callback: function($$v) {
                                _vm.sectionName = $$v
                              },
                              expression: "sectionName"
                            }
                          })
                        : _c("span", [
                            _vm._v(" " + _vm._s(_vm.catalogue.catalogName))
                          ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.addCatalogAndResourse }
                        },
                        [_vm._v("保存")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.clear }
                        },
                        [_vm._v("清空")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "zlItCourseEdit_editor" },
                  [
                    _vm.addType == 7 || _vm.addType == 8 || _vm.addType == 10
                      ? _c(
                          "transition",
                          { attrs: { name: "el-zoom-in-center" } },
                          [
                            _c("add-resourse", {
                              attrs: {
                                subjectId: _vm.subjectId,
                                type: _vm.addType
                              },
                              model: {
                                value: _vm.selectResourse,
                                callback: function($$v) {
                                  _vm.selectResourse = $$v
                                },
                                expression: "selectResourse"
                              }
                            })
                          ],
                          1
                        )
                      : _vm.addType == 6
                      ? _c(
                          "transition",
                          { attrs: { name: "el-zoom-in-center" } },
                          [
                            _c("add-mixed-mode", {
                              attrs: { subjectId: _vm.subjectId },
                              model: {
                                value: _vm.questionConfigure,
                                callback: function($$v) {
                                  _vm.questionConfigure = $$v
                                },
                                expression: "questionConfigure"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
          _vm.status === 3
            ? _c("div", { staticClass: "zlItCourseEdit_status_3" }, [
                _c("div", { staticClass: "zlItCourseEdit_status_3_c" }, [
                  _c("p", [_vm._v("在左侧创建目录，寻找加号，")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("创建目录时选择课程类型，")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("此处为课程展示和编辑区域，")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("如有问题，请联系管理人员。")])
                ])
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-725056d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725056d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/single_resource_course/zlItCourseEdit.vue
// module id = null
// module chunks = 